const ageVerifyDistricts = new Set([
  "Alabama",
  "Arizona",
  "Arkansas",
  "Florida",
  "Georgia",
  "Idaho",
  "Indiana",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Virginia",
  "Wyoming",
])

export default ageVerifyDistricts
